import { Component } from '@angular/core';

@Component({
  selector: 'app-no-mapping',
  imports: [],
  templateUrl: './no-mapping.component.html',
  styleUrl: './no-mapping.component.scss'
})
export class NoMappingComponent {

}
